import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HeroSection from "@/components/HeroSection";
import AccreditationBarometers from "@/components/AccreditationBarometers";
import CitizenExpectations from "@/components/CitizenExpectations";
import TalkSection from "@/components/TalkSection";
import PartiesEnActionSection from "@/components/PartiesEnActionSection";
import MediaDebatesSection from "@/components/MediaDebatesSection";
import PartiesSection from "@/components/PartiesSection";
import QuizBanner from "@/components/QuizBanner";
import ElectoralMap from "@/components/ElectoralMap";
import WhyParticipateSection from "@/components/WhyParticipateSection";
import ActionsCitoyennesSection from "@/components/ActionsCitoyennesSection";
import InstitutionsBar from "@/components/InstitutionsBar";
import { getCmsLayout, CmsLayout } from "@/data/cmsStore";
import { useI18n } from "@/i18n/I18nProvider";
import SEO from "@/components/SEO";

const Index = () => {
  const { lang } = useI18n();
  const [layout, setLayout] = useState<CmsLayout>([]);

  useEffect(() => {
    setLayout(getCmsLayout("home"));
    
    const handleLayoutChange = (e: any) => {
      if (e.detail?.page === "home") {
        setLayout(getCmsLayout("home"));
      }
    };
    window.addEventListener("cmsLayoutChanged", handleLayoutChange);
    return () => window.removeEventListener("cmsLayoutChanged", handleLayoutChange);
  }, []);

  const location = useLocation();

  useEffect(() => {
    if (layout.length > 0) {
      const pathToId: Record<string, string> = {
        "/pitcher": "pitcher",
        "/attentes-citoyennes": "pitcher",
        "/poster": "talk",
        "/accueil-talk": "talk",
        "/scroller": "agenda-national",
        "/agenda-national": "agenda-national",
        "/accueil-evenements": "agenda-national",
        "/watcher": "emissions",
        "/accueil-emissions": "emissions",
        "/politiquer": "partis",
        "/partis": "partis",
        "/logguer": "actions",
        "/actions": "actions",
        "/institutions": "institutions",
        "/ressources": "ressources",
        "/barometres": "accreditation-barometers-section",
        "/accueil-pourquoi": "pourquoi",
        "/accueil-quiz": "quizBanner",
      };
      
      const id = pathToId[location.pathname];
      if (id) {
        setTimeout(() => {
          const element = document.getElementById(id);
          if (element) {
            const y = element.getBoundingClientRect().top + window.pageYOffset - 80;
            window.scrollTo({ top: y, behavior: 'smooth' });
          }
        }, 100);
      } else if (location.pathname === "/") {
         window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  }, [location.pathname, layout]);

  return (
    <div className="min-h-screen bg-background">
      <SEO />
      <Navbar />
      
      {layout.length > 0 ? (
        layout.map((section) => {
          if (!section.visible) return null;
          
          switch (section.type) {
            case "HeroSection":
              return <HeroSection key={section.id} />;
            case "AccreditationBarometers":
              return <AccreditationBarometers key={section.id} />;
            case "CitizenExpectations":
              return (
                <div id="pitcher" key={section.id}>
                  <CitizenExpectations />
                </div>
              );
            case "TalkSection":
              return (
                <div id="talk" key={section.id}>
                  <TalkSection />
                </div>
              );
            case "PartiesEnActionSection":
              return (
                <div id="agenda-national" key={section.id}>
                  <PartiesEnActionSection />
                </div>
              );
            case "MediaDebatesSection":
              return (
                <div id="emissions" key={section.id}>
                  <MediaDebatesSection />
                </div>
              );
            case "PartiesSection":
              return (
                <div id="partis" key={section.id}>
                  <PartiesSection />
                </div>
              );
            case "QuizBanner":
              return <QuizBanner key={section.id} />;
            case "ElectoralMap":
              return <ElectoralMap key={section.id} />;
            case "WhyParticipateSection":
              return (
                <div id="pourquoi" key={section.id}>
                  <WhyParticipateSection />
                </div>
              );
            case "ActionsCitoyennesSection":
              return (
                <div id="actions" key={section.id}>
                  <ActionsCitoyennesSection />
                </div>
              );
            case "InstitutionsBar":
              return <InstitutionsBar key={section.id} />;
            case "CustomRichSection": {
              const langHtml = section.content[`html_${lang}`] || section.content.html_fr; // Default fallback
              return (
                <div key={section.id} className={`${section.content.bg_color || 'bg-background'} ${section.content.padding_y || 'py-12'}`}>
                  <div dangerouslySetInnerHTML={{ __html: langHtml || '' }} />
                </div>
              );
            }
            default:
              return null;
          }
        })
      ) : (
        <div className="h-screen flex items-center justify-center">
          <span className="animate-pulse">Chargement...</span>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Index;
